export default __webpack_public_path__ + "static/media/Adobe_XD_CC_icon.d42e60c4.svg";